import { IDatasetTypeMetadata } from 'app/extensibility/metadatas/resource-type/dataset-type-metadata';

import { SapEccResourceDataset } from 'app/model/dataset/sap-ecc-resource.dataset';
import { Metamodel } from 'app/model/base/model';
import { SapEccLinkedService } from 'app/model/linkedservice/sap-ecc.linkedservice';
import { httpRequestTimeoutMetadata } from '../consts/metadata-consts';

export const sapEccResourceMetadata: IDatasetTypeMetadata = {
    type: Metamodel.modelFor(SapEccResourceDataset).name,
    displayName: stringResources.SapEcc_DisplayText,
    supportLinkedServiceTypes: [Metamodel.modelFor(SapEccLinkedService).name],
    isSource: true,
    isSink: false,
    datasetKind: 'table',
    icon: {
        className: 'svg-i-100x100-sap_ecc'
    },
    tableNameDisplay: stringResources.PathLabel,
    tableNamePlural: stringResources.PathsLabel,
    isFirstClass: true,
    isTableNameRequired: true,
    supportCreatedAsV2: true,
    notSupportTypeConversion: true,
    notSupportPhysicalType: true,
    v1SupportSchema: true,
    category: ['ServicesApps'],
    copySourceControls: [httpRequestTimeoutMetadata]
};
